import styled from 'styled-components';
import CloseIcon from '../../../../Icons/CloseIcon';
import ArrowLeftDetailsOneIcon from '../../../../Icons/ArrowLeftDetailsOneIcon';
import ArrowRightDetailsOneIcon from '../../../../Icons/ArrowRightDetailsOneIcon';

export const WrapperDivContainer = styled.section(
  props => `

  border-radius: ${props.theme.misc.borderRadius.large};
  background-color: ${props.theme.colors.white.base};
  width: 92rem;
  // margin: ${props.theme.spacing.large.l20};
  // padding: ${props.theme.spacing.large.l25};
`,
);

export const CarouselImagesWrapper = styled.div(
  props => `
  overflow: auto;
  display: flex;
  flex-direction: row;
  position: relative;
  ::-webkit-scrollbar {
    display: none;
  }
  border-radius: ${props.theme.misc.borderRadius.large};
  -ms-overflow-style: none;
`,
);

export const RoomDetailsHeader = styled.p(
  props => `

  color: ${props.theme.colors.black.base};
  font-size:${props.theme.font.large.font22};
  font-weight:bold;

`,
);

export const RoomDetailsHeaderWrap = styled.div(
  props => `

  display:flex;
  position:sticky;
  top:0;
  border-bottom: 1px solid  ${props.theme.colors.blue.blueBorder};
  background-color: ${props.theme.colors.white.base};
  margin-bottom:${props.theme.spacing.large.l15};
  justify-content: space-between;
  align-items: center;
  padding-bottom: ${props.theme.spacing.large.l15};
  z-index: ${props.theme.misc.zIndex.small};
  padding: ${props.theme.spacing.large.l20};
  border-radius: ${props.theme.misc.borderRadius.custom(17)};
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;

`,
);

export const CloseIconWrap = styled(CloseIcon)(
  props => `

  color:${props.theme.colors.grey.grey75};
  cursor:pointer;

`,
);

export const MainGalleryOuterWrapDiv = styled.div(
  props => `
  position: relative;
  z-index: ${props.theme.misc.zIndex.xsmall};
`,
);

export const HotelMainGalleryImage = styled.img(
  props => `
  display: flex;
  width: 100%;
  height: 32.5rem;
  object-fit: cover;
`,
);

export const LeftArrowOuterWrapper = styled.div(
  props => `

  color: ${props.theme.colors.white.base};
  top: 15.5rem;
  left: 2rem;
  width: 3rem;
  height: 3rem;
  display: flex;
  border-radius: ${props.theme.misc.borderRadius.round};
  background-color: ${props.theme.colors.white.base};
  align-items: center;
  justify-content: center;
  cursor: pointer;
  position: fixed;
  transform: translateY(-50%);
  box-shadow:  0 .1rem .4rem 0 ${props.theme.colors.shadow.base};
  color: ${props.theme.colors.goBrand.blue};
  position: absolute;
  z-index: 9999;

`,
);

export const ImageTextWrapper = styled.div(
  props => `
    display: flex;
    position: absolute;
    bottom: 0;
    width: 100%;
    color: ${props.theme.colors.white.base};
    background: ${props.theme.colors.black.base};
    padding: ${props.theme.spacing.base};
    border-radius: 0 0 ${props.theme.misc.borderRadius.base} ${props.theme.misc.borderRadius.base};
    font-weight: ${props.theme.font.fontWeight.bold};
  `
);

export const RightArrowOuterWrapper = styled.div(
  props => `

  color: ${props.theme.colors.white.base};
  top: 15.5rem;
  right: 2rem;
  width: 3rem;
  height: 3rem;
  display: flex;
  border-radius: ${props.theme.misc.borderRadius.round};
  background-color: ${props.theme.colors.white.base};
  align-items: center;
  justify-content: center;
  cursor: pointer;
  position: fixed;
  transform: translateY(-50%);
  box-shadow:  0 .1rem .4rem 0 ${props.theme.colors.shadow.base};
  color: ${props.theme.colors.goBrand.blue};

  position: absolute;
  z-index: 9999;

`,
);

export const LeftArrow = styled(ArrowLeftDetailsOneIcon)(
  props => `

  width:1.5rem;
  height:1.5rem;

  `,
);

export const RightArrow = styled(ArrowRightDetailsOneIcon)(
  props => `

  width:1.5rem;
  height:1.5rem;

  `,
);

export const RoomDescription = styled.p(
  props => `

  color: ${props.theme.colors.grey.grey75};
  font-size:${props.theme.font.large.font16};
  line-height:1.5;
  padding: ${props.theme.spacing.large.l20} 0;

`,
);

export const RoomAmenitiesBodyWrap = styled.div(
  props => `

  padding: 0 ${props.theme.spacing.large.l20}; 

`,
);

export const RoomAmenitiesHeader = styled.p(
  props => `

  font-size:${props.theme.font.large.font18};
  font-weight:bold;
  color: ${props.theme.colors.black.base};
  line-height:1.38;
  margin: ${props.theme.spacing.large.l15} 0;

`,
);

export const RoomAmenitiesListWrapper = styled.ul(
  props => `

  display:flex;
  flex-wrap:wrap;
  color: ${props.theme.colors.grey.grey75};
  line-height:1.38;
  >li{
      width:33%
      list-style-type: none;
      position: relative;

  }
`,
);

export const RoomAmenitiesList = styled.p(
  props => `

  color: ${props.theme.colors.black.base};
  font-size:${props.theme.font.large.font16};
  margin-bottom: ${props.theme.spacing.large.l15};
  padding-top: ${props.theme.spacing.small.s5};
`,
);

export const AmenityListItem = styled.li(
  props => `
  display: flex;
`,
);

export const AmenityIconContainer = styled.div(
  props => `
  transform: translateY(0.4rem); /** to fix svg idiosyncrasy */
  padding: 0 ${props.theme.spacing.base} 0 0;
`,
);
